import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { addNewSession } from "../../../../../../../store/actions/admin/create-event";
import {
	setPanelOpen
} from "../../../../../../../store/actions/admin/event-panel";
import { useTypedSelector } from "../../../../../../../store/reducers/use-typed-selector";
import {
	CreateSession,
	SessionTypesEnum,
} from "../../../../../../../types/working-model";
import Icon, { COLORS, ICONS } from "../../../../../../general-ui/icon";
import SessionModal from "../../../../session/session-modal";

interface IActiveEventHeaderProps {
	title: string;
	// include add session button
	addSession?: boolean;
}

const ActiveEventHeader: React.FC<IActiveEventHeaderProps> = ({ title, addSession, children }) => {
	const {
		workingEvent,
		user,
		token,
	} = useTypedSelector((state) => ({
		workingEvent: state.CreateEventReducer.workingEvent,
		user: state.AuthReducer.user,
		token: state.AuthReducer.token,
	}));

	const history = useHistory();

	const [addingSession, setAddingSession] = useState<SessionTypesEnum | null>(null);

	const dispatch = useDispatch();

	const handleAddNewSession = () => {
		setAddingSession(SessionTypesEnum.onDemand);
	};

	const handleCloseModal = () => setAddingSession(null);

	function createSession(session: CreateSession) {
		//if the user didn't pick a language, they get english
		if (session.languages.length === 0) {
			session.languages = ['en'];
			session.default_language = 'en';
		}

		//if there's no default language, make it english if it exists, otherwise pick the first non-english language
		// or if the default language is not in the list
		if (!session.default_language || !session.languages.includes(session.default_language)) {
			if (session.languages.includes('en')) {
				session.default_language = 'en';
			} else {
				session.default_language = session.languages[0];
			}
		}

		dispatch(addNewSession(session, Number(workingEvent!.event), workingEvent!.uuid, user!.active_channel, token!));

		setAddingSession(null);
		return Promise.resolve();
	}

	return (
		<div className="panel-header">
			<div className="title">
				<div className="title-left">
					<button className="no-style" onClick={() => history.goBack()}>
						<Icon name={ICONS.ARROW_LEFT} size={16} color={COLORS.WHITE} />
					</button>
					<h6>{title}</h6>
				</div>
				<div className="buttons">
					{addSession ? (
						<button
							onClick={handleAddNewSession}
							className="clear no-styles add-session text-only-primary"
						>
							<Icon name={ICONS.ADD} color={COLORS.CYAN} size={12} />
							<span>Add session</span>
						</button>
					) : null}
					<button className='no-style' onClick={() => dispatch(setPanelOpen(false))}>
						<Icon name={ICONS.CLOSE} size={16} color={COLORS.DEFAULT_GRAY} />
					</button>
				</div>
			</div>
			{children && <div className="tabs-container">
				{children}
			</div>}
			<SessionModal
				addingSession={!!addingSession}
				addingSessionType={addingSession || undefined}
				closeModal={handleCloseModal}
				createSession={createSession}
			/>
		</div>
	);
};

export default ActiveEventHeader;
